import styled from 'styled-components'

export const FormContent = styled.div`
    width: 100%;
    padding: 20px;
    border: 1px solid #ddd;
    border-radius: 0px 0px 4px 4px;
    border-top: none;
    background: #fff;
`

export const ButtonContainer = styled.div<{ hasbackbutton: boolean }>`
    display: flex;
    width: 100%;
    justify-content: ${({ hasbackbutton }) => (hasbackbutton ? 'space-between' : 'flex-end')};
    margin-bottom: 1.5rem;
`

export const RemoveContainer = styled.div`
    display: flex;
    width: 100%;
    margin: auto;
    justify-content: center;
    margin-top: 2rem;
`
